export const ADD_FROM_GALLERY_LABEL = 'Aus Galerie hinzufügen';
export const ADD_FROM_CAMERA_LABEL = 'Foto aufnehmen';
export const NEW_MEDIA_LABEL = 'Neues Foto';
